import React from 'react';

import './brandSearchImage.css';

import brandImages from '../../config/brandConfigS3';
const S3_GEO_BUCKET = 'https://olleapps-geo.s3.us-west-2.amazonaws.com';

const BrandSearch = (props) => {
  const generateButtons = () => {
    const buttons = [];
    props.brands.forEach((brand) => {
      const matchedKey = Object.keys(brandImages).find(
        (k) => k.toLowerCase() === brand.toLowerCase()
      );
      if (matchedKey) {
        const isSelected = props.selectedBrand &&
          props.selectedBrand.toLowerCase() === brand.toLowerCase();
        buttons.push(
          <button
            type="button"
            className="btn ml-1 mt-1 btn-brand"
            key={`brand-${brand}`}
            title={brand}
            style={{
              border: isSelected ? '2px solid #dc3545' : '1px solid #ccc',
              boxShadow: isSelected ? '0 0 0 2px rgba(220,53,69,0.25)' : 'none',
              backgroundPosition: 'center',
              backgroundImage: `url(${S3_GEO_BUCKET}/logos/${brandImages[matchedKey]})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
            onClick={() => props.buttonCallback(true, brand)}
          />
        );
      }
    });
    return buttons;
  };

  return (
    <div
      className="btn-toolbar m-2"
      role="toolbar"
      aria-label="Toolbar Search Brands"
    >
      <div className="btn-group-lg me-2" role="group" aria-label="Brands">
        {props.extraButtons}
        {generateButtons()}
      </div>
    </div>
  );
};

export default BrandSearch;
